import { IssueInfoReasonType } from "../../lib/state/IssueInfoType";

export const reasonsDataByIssueReasonType: Record<IssueInfoReasonType, { title: string }> = {
    [IssueInfoReasonType.SecurityIssues]: { title: "Security issues" },
    [IssueInfoReasonType.LoginFailure]: { title: "Login failure" },
    [IssueInfoReasonType.DdosAttack]: { title: "DDOS attack" },
    [IssueInfoReasonType.Other]: { title: "" },
};
